import React from "react";
import { RCCButton, RCCTooltip } from "react-common-components";
import { PermissionEnum } from "src/context/Auth/interface";
import { useTranslation } from "src/context/Translations/context";
import CheckPermission from "../CheckPermission";
import { ISidebarCardButtons } from "./interface";

const SidebarCardButtons: React.FC<ISidebarCardButtons> = ({
	colorFiltersButton,
	onClickFilters,
	onClickPlus,
	labelButtonPlus,
	hasPermission = true
}) => {
	const { translate } = useTranslation();
	return(
		<>
			<CheckPermission minimumPermissionRequired={PermissionEnum.CREATE_UPDATE}>
				{(labelButtonPlus && onClickPlus) && hasPermission &&
				<RCCTooltip
					text={labelButtonPlus}
					color="purple"
				>
					<RCCButton
						icon={{name: "plus", color: "#FFF", size: 18}}
						color="purple"
						layout="isRounded"
						onClick={onClickPlus}
						size="md"
					/>
				</RCCTooltip>
				}													
			</CheckPermission>
			<RCCTooltip
				text={translate("Filtros")}
				color={colorFiltersButton}
			>
				<RCCButton
					icon={{name: "filter", color: "#FFF", size: 16}}
					color={colorFiltersButton}
					layout="isRounded"
					size="md"
					onClick={onClickFilters}
				/>
			</RCCTooltip>
		</>
	);
};

export default SidebarCardButtons;
